import { IQService } from "angular";
import {
  ChangeJournalObject,
  ChangeJournalObjectIdentifier,
  ChangeJournalObjectIdentifierEqual,
} from "./models";
import { ChangeJournalObjectContainerEntry } from "./itemObjectDetail/provider";
import { ChangeJournalViewItemService } from "./itemObjectDetail/service";

export class ChangeJournalObjectContainer {
  private readonly objects: {
    [objectName: string]: {
      [objectId: number]: ChangeJournalObjectContainerEntry;
    };
  } = {};

  constructor(
    private readonly changeJournalViewItemService: ChangeJournalViewItemService,
    initialEntries: ChangeJournalObjectContainerEntry[],
    private readonly $q: IQService
  ) {
    initialEntries.forEach((i) => this.setEntry(i));
  }

  getObjectEntry(
    id: ChangeJournalObjectIdentifier
  ): ChangeJournalObjectContainerEntry {
    const entry: ChangeJournalObjectContainerEntry = this.getEntry(id) ?? {
      id,
      promise: this.changeJournalViewItemService
        .resolveObjects(id)
        .then((objects) => {
          this.addObjectsToContainer(objects);
          return objects.find((o) =>
            ChangeJournalObjectIdentifierEqual(o.id, id)
          )!;
        }),
    };

    this.setEntry(entry);
    return entry;
  }

  addObjectsToContainer(objects: ChangeJournalObject[]) {
    objects.forEach((o) => {
      const config = this.changeJournalViewItemService.getConfigObject(
        o.id.ObjectName
      );
      this.setEntry({
        id: o.id,
        promise: this.$q.when(o),
      });
    });
  }

  private getEntry(
    id: ChangeJournalObjectIdentifier
  ): ChangeJournalObjectContainerEntry | undefined {
    return (this.objects[id.ObjectName] ??= {})[id.ObjectId];
  }

  private setEntry(entry: ChangeJournalObjectContainerEntry) {
    (this.objects[entry.id.ObjectName] ??= {})[entry.id.ObjectId] = entry;
  }
}
